import $ from 'gridstrap/lib/gs-zepto';
import * as smoothScroll from 'gridstrap/lib/smooth-scroll';

import { templates } from '../template';


export class GSProductListItems {

	//
	// Properties
	//

	private root;
	private top;

	//
	// Methods
	//

	loadMore(reset) {
		if (reset) this.root.html('');

		let current = this.top.products.current;
		let page = current.splice(0, 20);
		let rendered = page.map(product => templates.render('product', product));

		this.top.isFiltering = false;
		this.root.append(rendered.join('\n'));
		this.top.moreButton.isVisible = current.length > 0;
	}

	scrollToTop() {
		return new Promise<void>(resolve => {
			const offset = this.root.offset().top - 60;
			if (offset > window.scrollY) return resolve();
			$(document).one('scrollStop', () => resolve());
			smoothScroll.animateScroll(offset - 20);
		})
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
	}

	gsOnInit() {
		this.top = this.root.closest('.gs-ProductList').gs(0);
	}
}
